'use client'

import React, { useLayoutEffect } from 'react'

import { useFavouritingWishlisting } from './hooks/use-favouriting-wishlisting'

/**
 *  This base component gets called during layout
 * init and calls summary api to get saved items to save it in the favourites store
 * */

const FavouritingAndWishlisting: React.FC = () => {
  const { resetState } = useFavouritingWishlisting()

  useLayoutEffect(() => {
    resetState()
  }, [])

  return null
}

export { FavouritingAndWishlisting }
